import { render } from "./SegnalazioniHome.vue?vue&type=template&id=11c07952"
import script from "./SegnalazioniHome.vue?vue&type=script&lang=js"
export * from "./SegnalazioniHome.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__